import type { AuthorizedResourceAccessMap } from '@/permissions/adapter';
import { createAppRequest } from '@/services/request';

const request = createAppRequest();
export type BusinessType = 'state' | 'pevc' | 'cvc';
export interface PlatformConfig {
  enabledBusinessTypes: BusinessType[];
}
export const platformApi = {
  access: () =>
    request<{
      authorizedResourceAccess: AuthorizedResourceAccessMap;
      currentTenantIsAdmin: boolean;
    }>('/bff/platform/access'),
  config: () => request<PlatformConfig>('/bff/platform/config'),
  updateConfig: (data: PlatformConfig) =>
    request<PlatformConfig>('/bff/platform/config', { method: 'PUT', data }),
};
export const BUSINESS_TYPE_PRESETS = {
  state: {
    name: '国资／集团平台',
    focus: '多主体、投决留痕、穿透管理与政策目标',
    roleView: 'partner',
  },
  pevc: {
    name: '市场化 PE／VC',
    focus: '项目获取、尽调协作、组合业绩与 LP 服务',
    roleView: 'investmentManager',
  },
  cvc: {
    name: '企业 CVC',
    focus: '产业研究、直接出资与战略协同',
    roleView: 'research',
  },
} as const;
